<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>

  <div>

    <mat-form-field class="full-width">
      <input matInput placeholder="Code" [(ngModel)]="code" required />
    </mat-form-field>

  </div>

  <div>

    <mat-form-field class="full-width">
      <input matInput placeholder="Name" [(ngModel)]="name" required />
    </mat-form-field>

  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="primary" [disabled]="!code || !name">Create</button>
</div>

